import axios from 'axios'

export const downLoadPdf = (downloadUrl: string) => {
  return axios.get(`/amc-pdf-server/api/pdf/v1/print?downloadUrl=${downloadUrl}`, {
    timeout: 300000,
    responseType: 'blob'
  })
}

export const testPdf = () => {
  return axios.get('/amc-pdf-server/api/pdf/v1/', {
    timeout: 60000
  })
}
